/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Prices_Starting_AtInputs */

const en_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starting at ${i?.price}`)
};

const es_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desde ${i?.price}`)
};

const de_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ab ${i?.price}`)
};

const zh_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}起`)
};

const ar_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تبدأ من ${i?.price}`)
};

const fr_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`À partir de ${i?.price}`)
};

const vi_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bắt đầu từ ${i?.price}`)
};

const sw_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kuanzia ${i?.price}`)
};

const th_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มต้นที่ ${i?.price}`)
};

const bs_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Od ${i?.price}`)
};

const ja_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}から`)
};

const ko_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}부터`)
};

const pt_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A partir de ${i?.price}`)
};

const it_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A partire da ${i?.price}`)
};

const sv_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Från ${i?.price}`)
};

const nl_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vanaf ${i?.price}`)
};

const da_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fra ${i?.price}`)
};

const nb_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fra ${i?.price}`)
};

const fi_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alkaen ${i?.price}`)
};

const pl_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Od ${i?.price}`)
};

const ru_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`От ${i?.price}`)
};

const tr_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Başlangıç fiyatı: ${i?.price}`)
};

const hi_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} से शुरू`)
};

const id_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mulai dari ${i?.price}`)
};

const ms_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dari ${i?.price}`)
};

const cs_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Od ${i?.price}`)
};

const el_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Από ${i?.price}`)
};

const he_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`החל מ-${i?.price}`)
};

const af_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vanaf ${i?.price}`)
};

const hu_prices_starting_at = /** @type {(inputs: Prices_Starting_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kezdőár: ${i?.price}`)
};

/**
* | output |
* | --- |
* | "Starting at {price}" |
*
* @param {Prices_Starting_AtInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_starting_at = /** @type {((inputs: Prices_Starting_AtInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Starting_AtInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_starting_at(inputs)
	if (locale === "de") return de_prices_starting_at(inputs)
	if (locale === "zh") return zh_prices_starting_at(inputs)
	if (locale === "ar") return ar_prices_starting_at(inputs)
	if (locale === "fr") return fr_prices_starting_at(inputs)
	if (locale === "vi") return vi_prices_starting_at(inputs)
	if (locale === "sw") return sw_prices_starting_at(inputs)
	if (locale === "th") return th_prices_starting_at(inputs)
	if (locale === "bs") return bs_prices_starting_at(inputs)
	if (locale === "ja") return ja_prices_starting_at(inputs)
	if (locale === "ko") return ko_prices_starting_at(inputs)
	if (locale === "pt") return pt_prices_starting_at(inputs)
	if (locale === "it") return it_prices_starting_at(inputs)
	if (locale === "sv") return sv_prices_starting_at(inputs)
	if (locale === "nl") return nl_prices_starting_at(inputs)
	if (locale === "da") return da_prices_starting_at(inputs)
	if (locale === "nb") return nb_prices_starting_at(inputs)
	if (locale === "fi") return fi_prices_starting_at(inputs)
	if (locale === "pl") return pl_prices_starting_at(inputs)
	if (locale === "ru") return ru_prices_starting_at(inputs)
	if (locale === "tr") return tr_prices_starting_at(inputs)
	if (locale === "hi") return hi_prices_starting_at(inputs)
	if (locale === "id") return id_prices_starting_at(inputs)
	if (locale === "ms") return ms_prices_starting_at(inputs)
	if (locale === "cs") return cs_prices_starting_at(inputs)
	if (locale === "el") return el_prices_starting_at(inputs)
	if (locale === "he") return he_prices_starting_at(inputs)
	if (locale === "af") return af_prices_starting_at(inputs)
	if (locale === "hu") return hu_prices_starting_at(inputs)
	return en_prices_starting_at(inputs)
});